import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeficiencyTicketsLogicService } from './logic/deficiency-tickets/deficiency-ticket-logic.service';
import { DeficiencyTicketsService } from './logic/deficiency-tickets.service';
import { DeficiencyTicketsDaoService } from './dao/deficiency-tickets-dao.service';
import { DeficiencyTicketsDbDaoService } from './dao/deficiency-tickets/deficiency-tickets-db-dao.service';
import { DeficiencyTicketDbTableDefinition } from './dao/deficiency-tickets/deficiency-tickets-db-table-definition';
import { LocalDeficiencyTicketDbTableDefinition } from './dao/deficiency-tickets/local-deficiency-tickets-db-table-definition';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: DeficiencyTicketsService, useClass: DeficiencyTicketsLogicService },
    { provide: DeficiencyTicketsDaoService, useClass: DeficiencyTicketsDbDaoService },
    { provide: DeficiencyTicketDbTableDefinition },
    { provide: LocalDeficiencyTicketDbTableDefinition },
  ]
})
export class DeficiencyTicketsModule {}
